import React from 'react';
import { Button, MenuProps } from 'antd';
import { Article, KBEntity, Status, StatusValue, Statuses, Tag } from './admin-knowledge-base.type';
import { ControlType, iconsMap } from './components/controls';
import { ANIMATION_DURATION, formLabels } from './admin-knowledge-base.constants';
import dayjs, { Dayjs } from 'dayjs';
import { Types } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';
import {validatePrivileges} from "mixins/helpers";

export const getStatusValue = (status: Status): StatusValue => {
    if (status.planned === Statuses.PUBLISH) return StatusValue.PLANNED;
    if (status.planned === Statuses.ARCHIVE) return StatusValue.TO_DELETE;
    if (status.current === Statuses.PUBLISH) return StatusValue.PUBLISHED;
    if (status.current === Statuses.DRAFT) return StatusValue.DRAFT;
    if (status.current === Statuses.ARCHIVE) return StatusValue.DELETED;
    throw new Error('Unknown status');
};

export const getMenuItems = <Entity extends KBEntity>(
    entity: Entity,
    showUpdateForm: (entity: Entity) => void,
    showDeleteForm: (entity: Entity) => void,
    roles: string[],
    privileges: string[],
    privEdit,
    privDelete,
): MenuProps['items'] => {
    const items: Record<string, string>[] = [];

    if (validatePrivileges(roles, privileges, privEdit)) {
        items.push({
            key: 'update',
            label: (
                <Button
                    type="ghost"
                    onClick={() => showUpdateForm(entity)}
                    icon={iconsMap[ControlType.EDIT]}
                >
                    Редактировать
                </Button>
            ),
        });
    }

    if (validatePrivileges(roles, privileges, privDelete)) {
        items.push({
            key: 'delete',
            label: (
                <Button
                    type="ghost"
                    onClick={() => showDeleteForm(entity)}
                    icon={iconsMap[ControlType.DELETE]}
                >
                    Удалить
                </Button>
            ),
        });
    }

    return items;
};

export const getDeleteModalTitle = (type: Types) =>
    `Вы действительно хотите удалить ${formLabels[type]}?`;

export const disabledDate = (current: Dayjs) => {
    return (
        current &&
        (current > dayjs().add(183, 'day').startOf('day') || current <= dayjs().endOf('day'))
    );
};

export const isTag = (item: KBEntity): item is Tag => {
    return item?.type === Types.TAG;
};

export const isArticle = (item: KBEntity): item is Article => {
    return item?.type === Types.ARTICLE;
};

const moveFadeInOutKeyframes = [
    { opacity: 1, transform: 'translateX(0)' },
    { opacity: 0, transform: 'translateX(100%)', offset: 0.33 },
    { transform: 'translateX(-100%)', offset: 0.34 },
    { opacity: 1, transform: 'translateX(0)', offset: 1 },
];

const moveFadeInOutTiming = {
    duration: ANIMATION_DURATION,
    easing: 'ease-in-out',
};

export const animateForm = (element: HTMLDivElement) => {
    element.animate(moveFadeInOutKeyframes, moveFadeInOutTiming);
};
